var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._g(_vm._b({class:_vm.classes,style:(_vm.styles)},'i',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }